import { Collapse, Segmented } from 'antd'
import { useEffect, useMemo, useState } from 'react'
import CustomDetailPageConfig from './components/CustomDetailPageConfig'
import DetailImageUploader from './components/DetailImageUploader'
import OutputConfigPanel from './components/OutputConfigPanel'
import ProductInfoInput from './components/ProductInfoInput'
import styles from './index.module.scss'

const SmartDetailPlaceholder = ({
    referenceCollapseItems,
    referenceCollapseActiveKey,
    onReferenceCollapseChange,
    referenceExpandIcon,
    onOpenModelDrawer,
    onClearSelectedModel,
    hasSelectedModel,
    selectedModelUrl,
    detailImageList,
    onDetailImageListChange,
    productInfo,
    onProductInfoChange,
    mode,
    onModeChange,
    customItemList,
    onCustomItemListChange,
    clarity,
    onClarityChange,
    ratio,
    onRatioChange,
    platform,
    onPlatformChange,
    lang,
    onLangChange,
}) => {
    const [currentMode, setCurrentMode] = useState(mode || 'reference')

    useEffect(() => {
        if (!mode) return
        setCurrentMode(mode)
    }, [mode])

    useEffect(() => {
        onModeChange?.(currentMode)
    }, [currentMode, onModeChange])

    const segmentedOptions = useMemo(() => ([
        { label: '参考图模式', value: 'reference' },
        { label: '自定义模式', value: 'detail' },
    ]), [])

    return (
        <div className={styles.SmartDetailPlaceholder}>
            <div className={styles.Section}>
                <div className={styles.Title}>模特图/衣服图</div>
                <DetailImageUploader value={detailImageList} onChange={onDetailImageListChange} />
            </div>
            <div className={styles.Section}>
                <div className={styles.Title}>商品信息（必填）</div>
                <ProductInfoInput
                    value={productInfo}
                    onChange={onProductInfoChange}
                    detailImageList={detailImageList}
                />
            </div>
            <div className={styles.Section}>
                <Segmented
                    block
                    options={segmentedOptions}
                    value={currentMode}
                    onChange={setCurrentMode}
                    className={styles.ModeSegmented}
                />
                {currentMode === 'reference' ? (
                    <div className={styles.CollapseWrap}>
                        <Collapse
                            ghost
                            expandIconPosition="end"
                            items={referenceCollapseItems}
                            defaultActiveKey={referenceCollapseActiveKey}
                            activeKey={referenceCollapseActiveKey}
                            expandIcon={referenceExpandIcon}
                            onChange={onReferenceCollapseChange}
                        />
                    </div>
                ) : (
                    <CustomDetailPageConfig
                        value={customItemList}
                        onOpenModelDrawer={onOpenModelDrawer}
                        onClearSelectedModel={onClearSelectedModel}
                        hasSelectedModel={hasSelectedModel}
                        selectedModelUrl={selectedModelUrl}
                        onItemListChange={onCustomItemListChange}
                    />
                )}
            </div>
            <div className={styles.Section}>
                <OutputConfigPanel
                    clarity={clarity}
                    onClarityChange={onClarityChange}
                    ratio={ratio}
                    onRatioChange={onRatioChange}
                    platform={platform}
                    onPlatformChange={onPlatformChange}
                    lang={lang}
                    onLangChange={onLangChange}
                />
            </div>
        </div>
    )
}

export default SmartDetailPlaceholder
